module.exports = __webpack_public_path__ + "static/media/nftartgen.107b03d9.jpg";